import React, { useState, useEffect, Fragment } from 'react';
import { connect, useDispatch, useSelector } from 'react-redux';
import {
  Select,
  TextField,
  FormControl,
  IconButton,
  FormHelperText,
  InputLabel,
  MenuItem,
  makeStyles,
} from '@material-ui/core';
import { Form, Col, Row, Button, Image } from 'react-bootstrap';
import { AmealioLoader } from '../../../Loader/AmealioLoader';
import LeftSideNavigation from '../../navigationSection/LeftSideNavigation';
import RightSideNavigation from '../../navigationSection/RightSideNavigation';
import { NewInputText } from '../../../reusableComponents/inputReusableComponent/InputBoxComponent';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import FormatColorFillOutlinedIcon from '@material-ui/icons/FormatColorFillOutlined';
import ColorPicker from '../../../reusableComponents/colorPicker/colorPicker';
import {
  getCountries,
  getCountryCallingCode,
} from 'react-phone-number-input/input';
import DineInIcon from '../../../../assets/images/Orders/ordersdinein.png';
import en from 'react-phone-number-input/locale/en.json';

import {
  // prepareDataForValidation,
  useFormik,
} from 'formik';
import PropTypes from 'prop-types';
import * as yup from 'yup';
import moment from 'moment';
import { useHistory, useLocation } from 'react-router-dom';
import {
  CREATE_ORDER_VENDOR,
  FILTERED_MENU_ORDER,
  CLEAR_CART_DATA,
} from '../../../../../src/store/types';
import {
  get_category_menu_setup,
  get_category_menu_setup_with_loader,
} from '../../../../store/actions/VendorSubscriptionAction/vendorSubscriptionGetAction';
import {
  create_or_check_user_order,
  get_takeAway_time,
} from '../../../../store/actions/OrderingAction/vendorOrderingAction';
import { get_offers_details } from '../../../../store/actions/vendorOffersAndEventsAction';
import { get_current_restaurant_opening_status } from '../../../../store/actions/authAction';
import { vendor_get_available_table_action } from '../../../../store/actions/dashboardAction/addingAction';
import { dunzoQuote } from '../../../../store/actions/DunzoActions';
import Alert from 'react-s-alert';
import Media from 'react-media';
import { BottomNavigationMobile } from '../../navigationSection/BottomNavigationMobile';
import { CAR_COLORS, ORDER_TYPE } from '../../../../enums/OrderEnums';
import { DINE_IN_TOTAL_PAX } from '../../../../enums/OrderEnums';
import { amApi } from '../../../../api/apiHelper';
import { errorAlert } from '../../../../function/alert';
import isEmpty from '../../../../store/validation/is-Empty';
import { SavedAddress } from './savedAddress';
import MinDistanceModal from '../../../reusableComponents/MinDistanceModal';
import { deliveryConfig } from '../../../../config/Keys';
//

const useStyles = makeStyles((theme) => ({
  formControl: {
    minWidth: '100%',
    marginBottom: '1rem',
  },
  selectEmpty: {
    marginTop: theme.spacing(2),
  },
}));

const AddOrder = (props) => {
  let history = useHistory();
  const classes = useStyles();

  const locationState = useLocation();
  const [showSkipTheLine, setShowSkipTheLine] = useState(false);
  const [showHomeDelivery, setShowHomeDelivery] = useState(false);
  const [showTakeAway, setShowTakeAway] = useState(false);
  const [showCurbSide, setShowCurbSide] = useState(false);
  const [showDineIn, setShowDineIn] = useState(false);
  const data = locationState?.state?.data || null;
  const [background, setBackground] = useState({
    color: data?.background || '#EE3A23',
    picker: false,
  });
  const onChangeHandler = (type) => (color) => {
    if (type === 'BACKGROUND')
      setBackground({ color: color, picker: !background.picker });
    formik.setFieldValue('curb_side_details.color', color);
  };

  const [showNowButton, setShowNowButton] = useState(false);
  const [showLaterTakeAway, setShowLaterTakeAway] = useState(false);
  const [showLaterCurbSide, setShowLaterCurbSide] = useState(false);
  const [showLaterSkipTheLine, setShowLaterSkipTheLine] = useState(false);
  const [showLaterDineIn, setShowLaterDineIn] = useState(false);
  const [showLaterHomeDelivery, setShowLaterHomeDelivery] = useState(false);

  const dineInMaximumPerson =
    props?.subscriptionData?.ordering?.dine_in_order?.maximum_person;

  const dispatch = useDispatch();
  const validate = (values) => {
    const errors = {};
    const regex = RegExp(/^[A-Z]{2}\s[0-9]{2}\s[A-Z,0-9]{2}\s[0-9]{4}$/i);

    if (values.order_type === 1) {
      if (!values.curb_side_details.number) {
        errors.number = 'Please enter vehicle number';
      } else if (!regex.test(values.curb_side_details.number)) {
        errors.number = 'Invalid vehicle number';
      }
      if (!values.curb_side_details.make) {
        errors.make = 'Please enter make';
      }
      // if (!values.curb_side_details.model) {
      //   errors.model = "Please enter model";
      // }
      // if (!values.curb_side_details.year) {
      //   errors.year = "Please enter year";
      // }
      if (!values.curb_side_details.color) {
        errors.color = 'Please enter color';
      }
      if (!values.curb_side_details.pickUpPoint) {
        errors.pickUpPoint = 'Select pickUp Point';
      }
    }

    if (values.order_type === 3) {
      if (props?.subscriptionData?.seating?.table_management?.value) {
        if (!values.dine_in_details?.table_number) {
          errors.table_number = 'Please enter table number';
        }
      }
      if (!values.totalDinePax) {
        errors.totalDinePax = 'Please enter Total Pax number';
      } else if (values.totalDinePax > dineInMaximumPerson) {
        errors.totalDinePax = `Maximum party size is ${dineInMaximumPerson} PAX. Please try again`;
      }
    }

    // if (values.food_type.length === 0) {
    //   errors.food_type = "Please select food type";
    // }

    return errors;
  };
  const [state, setState] = useState({
    takeaway: 0,
    ordertype: 0,
    vehical_type: 4,
    deliverytype: 0,
    vehical_type_value: '4-wheeler',
  });

  const { takeaway, ordertype, vehical_type, deliverytype } = state;

  const maxLengthCheck = (object) => {
    if (object.target.value.length > object.target.maxLength) {
      object.target.value = object.target.value.slice(
        0,
        object.target.maxLength
      );
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === ' ') {
      e.preventDefault();
    }
  };

  const onChangeTakeAwayNow = () => {
    setState({ ...state, takeaway: 0 });
    formik.setFieldValue('now', true);
    formik.setFieldValue('later_date', '');
  };

  const onChangeTakeAwayLater = () => {
    setState({ ...state, takeaway: 1 });
    formik.setFieldValue('now', false);
    formik.setFieldValue('later_date', minDate);
  };

  const onChangeHomeDeliveryNow = () => {
    setState({ ...state, takeaway: 0 });
    formik.setFieldValue('now', true);
    formik.setFieldValue('later_date', '');
  };

  const onChangeHomeDeliveryLater = () => {
    setState({ ...state, takeaway: 1 });
    formik.setFieldValue('now', false);
    formik.setFieldValue('later_date', minDate);
  };

  const onClickChangeVechileType = (data) => {
    setState({
      ...state,
      vehical_type: data.id,
      vehical_type_value: data.title,
    });
    formik.setFieldValue('curb_side_details.vehical_type', data.id);
    formik.setFieldValue('curb_side_details.vehical_type_value', data.title);
  };

  const onChangeOrderType = (id) => {
    setState({ ...state, ordertype: id });
    formik.setFieldValue('order_type', id);
    if (id === 7 && formik?.values?.address?.location?.latitude) {
      checkDistance(
        formik.values?.address?.location.latitude,
        formik.values?.address?.location?.longitude
      );
    }
  };

  const [userData, setUserData] = useState('');
  const [selectedAddress, setSelectedAddress] = useState('');

  const handleNumber = async (data) => {
    let params = {
      mobile_number:
        data.mobile_number || formik.values?.user_details?.mobile_number,
      country_code:
        data?.country_code || formik.values?.user_details?.country_code,
    };
    let mobiReg = /^[6-9]\d{9}$/;
    if (mobiReg.test(params.mobile_number)) {
      let userRes = await amApi.get('/user-check', { params: params });
      if (userRes.status === 200 && !isEmpty(userRes.data)) {
        setUserData(userRes.data);
        setSelectedAddress(userRes.data?.defaultAddress || '');
        if (state.ordertype === 7) {
          checkDistance(
            userRes.data?.defaultAddress?.location.latitude,
            userRes.data?.defaultAddress?.location?.longitude,
            userRes.data?.deliveryAddress
          );
        }
        formik.setFieldValue('address', userRes.data?.defaultAddress);
        formik.setFieldValue(
          'deliveryAddress',
          userRes.data?.defaultAddress?._id
        );
        if (!data.first_name) {
          formik.setFieldValue(
            'user_details.first_name',
            userRes.data?.first_name
          );
          formik.setFieldValue(
            'user_details.last_name',
            userRes.data?.last_name
          );
        }
      } else {
        setUserData({ mobile_number: params.mobile_number });
        if (!data.first_name) {
          formik.setFieldValue('user_details.first_name', '');
          formik.setFieldValue('user_details.last_name', '');
        }
      }
      formik.setFieldValue(
        'delivery_partner',
        props?.subscription?.delivery_partner
      );
    } else {
      errorAlert('Invalid Mobile Number');
    }
  };

  const [distModal, setDistModal] = useState(false);

  const checkDistance = async (lat, lng, data) => {
    let params = { lat: lat, long: lng };
    let dist = await amApi.get(
      `/check/restaurant-dist/${props.onboarding?._id}`,
      { params: params }
    );
    if (dist.status === 200 && !dist.data.continue) {
      setDistModal(true);
    } else {
      if (data) {
        formik.setFieldValue('address', data);
        formik.setFieldValue('deliveryAddress', data?._id);
      }
    }
  };

  const handleAddress = (data) => {
    if (data === 'NEW') {
      setSelectedAddress(data);
      formik.setFieldValue('address', '');
      formik.setFieldValue('deliveryAddress', '');
    } else {
      setSelectedAddress(data);
      checkDistance(data.location.latitude, data.location?.longitude, data);
    }
  };

  const tempAddress = (data) => {
    checkDistance(data.location.latitude, data.location?.longitude, data);
  };

  const distCheck = (lat, long) => {
    checkDistance(lat, long, null);
  };

  const onClickNext = (e) => {
    e.preventDefault();
    formik.handleSubmit();
  };

  const orderTypes = [
    {
      id: 0,
      title: 'Takeaway',
      show: showTakeAway,
      image: require('../../../../assets/images/seatingImages/takeawayicon.svg'),
      // image: require("../../../../assets/images/Orders/takeaway.svg"),
    },
    {
      id: 1,
      title: 'Curb-side',
      show: showCurbSide,
      image: require('../../../../assets/images/seatingImages/curbsideicon.svg'),
    },
    {
      id: 3,
      title: 'Dine-In',
      show: showDineIn,
      image: DineInIcon,
    },
    {
      id: 2,
      title: 'Skip-The Line',
      show: showSkipTheLine,
      image: require('../../../../assets/images/superadmin/ordericon/skipTheLine.svg'),
    },
    {
      id: 4,
      title: 'Buffet',
      show: false,
      image: require('../../../../assets/images/Orders/Buffet.svg'),
    },
    {
      id: 7,
      title: 'Delivery',
      show: showHomeDelivery,
      image: require('../../../../assets/images/superadmin/ordericon/delivery.svg'),
    },
    {
      id: 6,
      title: 'Drive Thru',
      show: false,
      image: require('../../../../assets/images/Orders/Drive thru.svg'),
    },
    {
      id: 9,
      title: 'Catering',
      show: false,
      image: require('../../../../assets/images/Orders/catering.svg'),
    },
  ];

  const [timeSlots, setTimeSlots] = useState([]);

  const prepareData = (data, selectedDate) => {
    let tempData = [];
    for (let i = 0; i < data.length; i++) {
      tempData.push({
        id: i,
        title: data[i],
        value: (data[i].slice(0, -2) + ':00').replace(/\s/g, ''),
      });
    }
    setTimeSlots(tempData);
    formik.setFieldValue('later_date', selectedDate);
    formik.setFieldValue('later_formDated_date', '');
    setDateTime('');
  };

  const [timeDate, setDateTime] = useState('');
  const onSuccessGetTime = (data, selectedDate) => {
    let CurrentDate = new Date();
    let selectedDateFormat = new Date(selectedDate);
    prepareData(data, selectedDate);
    // if (selectedDateFormat > CurrentDate) {
    //   prepareData(data, selectedDate);
    // } else {
    //   let min = moment().format("hh:mm A");
    //   let max = "11:59 PM";
    //   let result = [];
    //   if (min.slice(-2) === "PM") {
    //     let filteredPM = data.filter((word) => word.includes("PM"));
    //     for (let i = 0; i < filteredPM.length; i++) {
    //       if (filteredPM[i][1] === ":") {
    //         filteredPM[i] = "0" + filteredPM[i];
    //       }
    //     }
    //     result = filteredPM.filter((a) => a > min && a < max);
    //     prepareData(result, selectedDate);
    //   } else {
    //     max = "11:59 AM";
    //     let filteredPM = data.filter((word) => word.includes("PM"));
    //     let filteredAM = data.filter((word) => word.includes("AM"));
    //     for (let i = 0; i < filteredAM.length; i++) {
    //       if (filteredAM[i].startsWith("0")) {
    //         filteredAM[i] = "0" + filteredAM[i];
    //       }
    //     }
    //     result = filteredAM.filter((a) => a > min && a < max);
    //     result = [...result, ...filteredPM];
    //     prepareData(result, selectedDate);
    //   }
    // }
  };

  const vendorAccessId = useSelector((state) =>
    state.vendorAccess ? state.vendorAccess?.vendor_id : null
  );

  const onChangeDate = (date) => {
    const token = props.auth.user.accessToken;
    formik.setFieldValue('actual_date', date);
    const vendorId = vendorAccessId
      ? vendorAccessId
      : props.auth.user.VendorUser._id;
    props.get_takeAway_time(
      token,
      vendorId,
      formik.values.order_type === 0
        ? 'TAKEAWAY'
        : formik.values.order_type === 1
        ? 'CURBSIDE'
        : '',
      date,
      onSuccessGetTime,
      (err) => onError(err)
    );
  };

  const y = (id, timeValue, title) => {
    let formDate = new Date(
      `${moment(formik.values.later_date).format('YYYY-MM-DD')} ${title}`
    ).getTime();
    formik.setFieldValue('later_formDated_date', formDate);
    // formik.setFieldValue("later_formDated_date", title);
    formik.setFieldValue('later_time', title);
    setDateTime(id);
  };

  const onError = (err) => {
    Alert.error(`<h4>${err?.data?.message}</h4>`, {
      position: 'top-right',
      effect: 'bouncyflip',
      beep: true,
      html: true,
      timeout: 3000,
      offset: 35,
    });
  };

  const formik = useFormik({
    initialValues: {
      user_details: {
        first_name: '',
        last_name: '',
        country_code: '',
        mobile_number: '',
      },
      order_type: '',
      now: true,
      nowDate: new Date(),
      later_date: '',
      later_time: '',
      actual_date: '',
      later_formDated_date: '',
      delivery_partner: 1,
      curb_side_details: {
        vehical_type: vechileTypes?.[0]?.id || '',
        vehical_type_value: vechileTypes?.[0]?.title || '',
        number: '',
        make: '',
        model: '',
        year: '',
        color: '',
        pickUpPoint: null,
      },
      dine_in_details: {
        table_number: '',
      },
      totalDinePax: 0,
    },
    validationSchema: yup.object({
      user_details: yup.object({
        first_name: yup
          .string()
          .required('First name is required')
          .matches(/^[aA-zZ\s]+$/, 'Only alphabets are allowed')
          .min(1, 'Minimum 1 Character')
          .max(64, 'Maximum 64 Character'),
        last_name: yup
          .string()
          .required('Last name is required')
          .matches(/^[aA-zZ\s]+$/, 'Only alphabets are allowed')
          .min(1, 'Minimum 1 Character')
          .max(64, 'Maximum 64 Character'),
        mobile_number: yup
          .string()
          .matches(/^[0-9]+$/, 'Must be only digits')
          .required('Phone number is required')
          .min(10, 'Phone number must be of 10 characters')
          .max(10, 'Phone number must be of 10 characters'),
      }),
    }),
    validate,
    //enableReinitialize: true,
    onSubmit: (values) => {
      if (values.user_details.first_name.trim() === '') {
        formik.setErrors({
          user_details: {
            first_name: 'First name field cannot be left blank',
          },
        });
      } else if (values.user_details.last_name.trim() === '') {
        formik.setErrors({
          user_details: {
            last_name: 'Last name field cannot be left blank',
          },
        });
      } else if (values.order_type === '') {
        Alert.error(`<h4>Please select one relevant option</h4>`, {
          position: 'top-right',
          effect: 'bouncyflip',
          beep: true,
          html: true,
          timeout: 3000,
          offset: 35,
        });
      } else {
        if (values.order_type === 0 && timeDate === '' && !values.now) {
          Alert.error(`<h4>Please select time</h4>`, {
            position: 'top-right',
            effect: 'bouncyflip',
            beep: true,
            html: true,
            timeout: 3000,
            offset: 35,
          });
        } else if (values.order_type === 1 && timeDate === '' && !values.now) {
          Alert.error(`<h4>Please select time</h4>`, {
            position: 'top-right',
            effect: 'bouncyflip',
            beep: true,
            html: true,
            timeout: 3000,
            offset: 35,
          });
        } else if (values.order_type === 7 && !values.deliveryAddress) {
          errorAlert('Please select Address');
        } else {
          let orderSelected = '';
          if (values.order_type === 0) {
            orderSelected = 'take_away';
          } else if (values.order_type === 1) {
            orderSelected = 'curb_side';
          } else if (values.order_type === 2) {
            orderSelected = 'skip_line';
          } else if (values.order_type === 3) {
            orderSelected = 'dine_in';
          } else if (values.order_type === 7) {
            orderSelected = 'home_delivery';
          }

          let filteredMenuData = [];

          for (let i = 0; i < props.menuCategory.length; i++) {
            let tempCategory = JSON.parse(
              JSON.stringify(props.menuCategory[i])
            );
            tempCategory.items = [];

            //tempCategory.items.filteredItems = [];

            for (let j = 0; j < props.menuCategory[i].items.length; j++) {
              if (
                props.menuCategory?.[i].items?.[j]?.[orderSelected]?.value &&
                props.menuCategory?.[i].items?.[j]?.status
              ) {
                let dataToSend = JSON.parse(
                  JSON.stringify(props.menuCategory[i].items[j])
                );

                dataToSend[orderSelected].sizes = [];
                dataToSend.cartLength = 0;

                for (
                  let m = 0;
                  m <
                  props.menuCategory[i].items[j][orderSelected].sizes.length;
                  m++
                ) {
                  if (
                    props.menuCategory[i].items[j][orderSelected].sizes[m]
                      .available
                  ) {
                    dataToSend[orderSelected].sizes.push(
                      props.menuCategory[i].items[j][orderSelected].sizes[m]
                    );
                  }
                }

                tempCategory.items.push(dataToSend);
              }
            }
            if (tempCategory.items.length > 0) {
              filteredMenuData.push(tempCategory);
            }
            tempCategory = {};
          }

          values.orderSelected = orderSelected;
          values.get_receipt_email = false;
          if (
            values.order_type === 0 ||
            (values.order_type === 1 && !values.now)
          ) {
            values.later_date = values.later_formDated_date;
            values.later_time = values.later_time;
            values.actual_date = values.actual_date;
          } else if (values.order_type === 0 && values.now) {
            values.later_date = new Date().getTime();
          }
          values.delivery_partner = props?.subscription?.delivery_partner;
          const OnSuccessUserId = async (userId, email) => {
            if (
              props?.subscription?.delivery_partner === 2 &&
              formik?.values?.order_type === 7
            ) {
              let dunzo_quote = await props.dunzoQuote({
                max_time: 30,
                user: {
                  first_name: formik?.values?.user_details?.first_name || '',
                  last_name: formik?.values?.user_details?.last_name || '',
                  country_code:
                    formik?.values?.user_details?.country_code || '',
                  mobile_number:
                    formik?.values?.user_details?.mobile_number || '',
                  address: selectedAddress,
                },
                restaurant: {
                  coordinates: props?.onboarding?.location?.coordinates || [],
                  area: props?.onboarding?.area || '',
                  city: props?.onboarding?.city || '',
                  pinCode: props?.onboarding?.pinCode || '',
                  restaurant_address:
                    props?.onboarding?.restaurant_address || '',
                  restaurant_name: props?.onboarding?.restaurant_name || '',
                  contact_detail: props?.onboarding?.contact_detail || [],
                },
              });

              let deliveryCharges = { merchant: 0, amealio: 0, user: 0 };
              if (props?.deliveryConfig?.isPercentage) {
                if (props?.deliveryConfig?.hasOwnProperty('userCharge')) {
                  deliveryCharges.user =
                    (dunzo_quote?.estimated_price *
                      props?.deliveryConfig?.userCharge) /
                    100;
                  deliveryCharges.merchant =
                    (dunzo_quote?.estimated_price *
                      props?.deliveryConfig?.merchantCharge) /
                    100;
                  deliveryCharges.amealio =
                    (dunzo_quote?.estimated_price *
                      props?.deliveryConfig?.amealioCharge) /
                    100;
                } else {
                  deliveryCharges.user =
                    (dunzo_quote?.estimated_price *
                      deliveryConfig.USER_CHARGE) /
                    100;
                  deliveryCharges.merchant =
                    (dunzo_quote?.estimated_price *
                      deliveryConfig.MERCHANT_CHARGE) /
                    100;
                  deliveryCharges.amealio =
                    (dunzo_quote?.estimated_price *
                      deliveryConfig.AMEALIO_CHARGE) /
                    100;
                }
              } else if (props?.deliveryConfig?.isFixed) {
                if (dunzo_quote?.distance > 3) {
                  deliveryCharges.merchant = Math.min(
                    dunzo_quote?.estimated_price,
                    props?.deliveryConfig?.fixedCharges?.above3?.merchant
                  );
                  deliveryCharges.amealio = Math.min(
                    dunzo_quote?.estimated_price - deliveryCharges.merchant,
                    props?.deliveryConfig?.fixedCharges?.above3?.amealio
                  );
                  deliveryCharges.user = Math.max(
                    0,
                    dunzo_quote?.estimated_price -
                      (deliveryCharges.merchant + deliveryCharges.amealio)
                  );
                } else {
                  if (
                    props?.deliveryConfig?.fixedCharges?.below3.borneByMerchant
                  ) {
                    deliveryCharges.merchant = dunzo_quote?.estimated_price;
                    deliveryCharges.amealio = 0;
                    deliveryCharges.user = 0;
                  } else {
                    deliveryCharges.merchant = Math.min(
                      dunzo_quote?.estimated_price,
                      props?.deliveryConfig?.fixedCharges?.below3?.merchant
                    );
                    deliveryCharges.amealio = Math.min(
                      dunzo_quote?.estimated_price - deliveryCharges.merchant,
                      props?.deliveryConfig?.fixedCharges?.below3?.amealio
                    );
                    deliveryCharges.user = Math.max(
                      0,
                      dunzo_quote?.estimated_price -
                        (deliveryCharges.merchant + deliveryCharges.amealio)
                    );
                  }
                }
              }
              values.delivery_quote = dunzo_quote?._id || null;
              values.deliveryCharges = deliveryCharges;
            }

            values.user_details.userId = userId;
            values.user_details.email = email;
            values.payment_method = 6;
            values.payment_pending = false;
            values.selectedTabId = 1;
            values.tip = { value: 0, amount: 0 };
            values.donation = { value: 1, amount: 2 };
            await dispatch({ type: CREATE_ORDER_VENDOR, payload: values });
            await dispatch({
              type: FILTERED_MENU_ORDER,
              payload: filteredMenuData,
            });

            history.push('/orderrequest');
          };
          const userData = {
            country_code: values.user_details.country_code,
            mobile_number: values.user_details.mobile_number,
            first_name: values.user_details.first_name,
            last_name: values.user_details.last_name,
          };
          if (values.user_details.first_name[0] === ' ') {
            formik.setErrors({
              user_details: { first_name: 'Please enter a valid first name' },
            });
          } else if (values.user_details.last_name === ' ') {
            formik.setErrors({
              user_details: { last_name: 'Please enter a valid last name' },
            });
          } else {
            const token = props.auth.user.accessToken;
            props.create_or_check_user_order(token, userData, OnSuccessUserId);
          }
        }
      }
    },
  });

  const [minDate, setMinDate] = useState('');
  const [maxDateTakeAway, setMaxDateTakeAway] = useState('');
  const [maxDateSkipLine, setMaxDateSkipLine] = useState('');
  const [maxDateCurbSide, setMaxDateCurbSide] = useState('');
  const [pickupPointData, setPickupPointData] = useState([]);

  const handleChangePickupPoint = (e) => {
    let selectedData = pickupPointData;
    formik.setFieldValue(
      'curb_side_details.pickUpPoint',
      selectedData && selectedData[e.target.value]
    );
  };

  useEffect(() => {
    let data = moment().format('YYYY-MM-DD');
    onChangeDate(data);
    setMinDate(data);
    let takeAwayMaxDate = props?.servicesEnabled?.take_away?.max_date - 1;
    let skipLineMaxDate = props?.servicesEnabled?.self_serve?.max_date - 1;
    let curbSideMaxDate =
      props?.servicesEnabled?.cubside_delivery?.max_date - 1;
    if (
      props.servicesEnabled &&
      props.servicesEnabled.cubside_delivery &&
      props.servicesEnabled.cubside_delivery.order_for_future
    ) {
      let myDate = new Date(
        new Date().getTime() + curbSideMaxDate * 24 * 60 * 60 * 1000
      );
      let formatDate = moment(myDate).format('YYYY-MM-DD');
      setMaxDateCurbSide(formatDate);
    }

    if (
      props.servicesEnabled &&
      props.servicesEnabled.take_away &&
      props.servicesEnabled.take_away.order_for_future
    ) {
      let myDate = new Date(
        new Date().getTime() + takeAwayMaxDate * 24 * 60 * 60 * 1000
      );
      let formatDate = moment(myDate).format('YYYY-MM-DD');
      setMaxDateTakeAway(formatDate);
    }

    if (
      props.servicesEnabled &&
      props.servicesEnabled.self_serve &&
      props.servicesEnabled.self_serve.order_for_future
    ) {
      let myDate = new Date(
        new Date().getTime() + skipLineMaxDate * 24 * 60 * 60 * 1000
      );
      let formatDate = moment(myDate).format('YYYY-MM-DD');
      setMaxDateSkipLine(formatDate);
    }
  }, [props.servicesEnabled]);

  useEffect(() => {
    if (props?.orderData?.user_details) {
      // console.log("props.orderData", props.orderData);
      formik.setValues(props.orderData);
      formik.setFieldValue('deliveryAddress', null);

      if (
        userData?.mobile_number !==
        props?.orderData?.user_details?.mobile_number
      )
        handleNumber(props?.orderData?.user_details);

      setUserData(props?.orderData?.user_details);
      // setState({
      //   ...state,
      //   ordertype: formik.values.order_type,
      //   vehical_type: formik.values.curb_side_details.vehical_type,
      // });
      onChangeOrderType(props?.orderData?.order_type);
    } else {
      dispatch({ type: CLEAR_CART_DATA, payload: [] });
    }
  }, [props.orderData]);

  useEffect(() => {
    const token = props.auth.user.accessToken;
    const vendorId = vendorAccessId
      ? vendorAccessId
      : props.auth.user.VendorUser._id;
    props.get_takeAway_time(
      token,
      vendorId,
      ORDER_TYPE[formik.values.order_type],
      moment().format('YYYY-MM-DD'),
      onSuccessGetTime,
      (err) => onError(err)
    );
    setPickupPointData(
      props.servicesEnabled?.cubside_delivery?.pickup_location
    );
  }, [formik.values.order_type]);

  const [displayTakeAwayNext, setDisplayTakeAwayNext] = useState(false);
  const [displayCurbSideNext, setDisplayCurbSideNext] = useState(false);
  const [displayDineInNext, setDisplayDineInNext] = useState(false);
  const [displaySkipNext, setDisplaySkipNext] = useState(false);
  const [displayDeliveryNext, setDisplayDeliveryNext] = useState(false);
  const [availableTableData, setAvailableTableData] = useState([]);

  useEffect(() => {
    if (props.auth.user.VendorUser.country_code) {
      formik.setFieldValue(
        'user_details.country_code',
        props.auth.user.VendorUser.country_code
      );
    }

    const token = props.auth.user.accessToken;
    const userData = props.auth.user;
    // dispatch(
    //   get_current_restaurant_opening_status(token, onSuccessOpen, (err) =>
    //     onErrorSuccess(err)
    //   )
    // );
    props.get_current_restaurant_opening_status(token, onSuccessOpen, (err) =>
      onErrorSuccess(err)
    );
    // if (!props?.menuCategory || props?.menuCategory?.length === 0) {
    props.get_category_menu_setup(token);
    // }

    props.get_offers_details(token);
    let startDate = moment(new Date()).format('YYYY-MM-DD');
    let finalStartDate = startDate + ' ' + '00:00';
    let endDate = moment(new Date()).format('YYYY-MM-DD');
    let finalendDate = endDate + ' ' + '23:59';
    props.vendor_get_available_table_action(
      userData.VendorUser._id,
      finalStartDate,
      finalendDate,
      token
    );

    if (
      props?.onboarding?.sessionSettings?.restaurant_open ||
      props?.onboarding?.future_activities?.order?.take_away
    ) {
      setDisplayTakeAwayNext(true);
    }
    if (
      props?.onboarding?.sessionSettings?.restaurant_open ||
      props?.onboarding?.future_activities?.order?.curb_side
    ) {
      setDisplayCurbSideNext(true);
    }
    if (
      props?.onboarding?.sessionSettings?.restaurant_open ||
      props?.onboarding?.future_activities?.order?.dine_in_order
    ) {
      setDisplayDineInNext(true);
    }
    if (
      props?.onboarding?.sessionSettings?.restaurant_open ||
      props?.onboarding?.future_activities?.order?.skip_line
    ) {
      setDisplaySkipNext(true);
    }
    if (
      props?.onboarding?.sessionSettings?.restaurant_open ||
      props?.onboarding?.future_activities?.order?.home_delivery
    ) {
      setDisplayDeliveryNext(true);
    }

    /************* @DESC Current Status ***********/
    if (
      props?.servicesEnabled?.take_away?.value &&
      props?.sessionSettings?.take_away
    ) {
      onChangeOrderType(0);
    } else if (
      props?.servicesEnabled?.cubside_delivery?.value &&
      props?.sessionSettings?.curb_side
    ) {
      onChangeOrderType(1);
    } else if (
      props?.servicesEnabled?.dine_in_order?.value &&
      props?.sessionSettings?.dine_in_order
    ) {
      onChangeOrderType(3);
    } else if (
      props?.servicesEnabled?.home_delivery?.value &&
      props?.sessionSettings?.home_delivery
    ) {
      onChangeOrderType(7);
    } else if (
      props?.servicesEnabled?.self_serve?.value &&
      props?.sessionSettings?.skip_line
    ) {
      onChangeOrderType(2);
    } else {
      formik.setFieldValue('order_type', '');
    }
  }, []);

  useEffect(() => {
    if (props.getAvailableTableData !== availableTableData) {
      setAvailableTableData(props.getAvailableTableData);
    }
  }, [props.getAvailableTableData]);

  const onSuccessOpen = () => {};

  const onErrorSuccess = (err) => {
    Alert.error(`<h4>${err?.response?.data?.message}</h4>`, {
      position: 'top-right',
      effect: 'bouncyflip',
      beep: true,
      html: true,
      timeout: 3000,
      offset: 35,
    });
  };

  useEffect(() => {
    if (
      props?.onboarding?.sessionSettings?.restaurant_open ||
      props?.onboarding?.future_activities?.order?.take_away
    ) {
      setDisplayTakeAwayNext(true);
    }
    if (
      props?.onboarding?.sessionSettings?.restaurant_open ||
      props?.onboarding?.future_activities?.order?.curb_side
    ) {
      setDisplayCurbSideNext(true);
    }
    if (
      props?.onboarding?.sessionSettings?.restaurant_open ||
      props?.onboarding?.future_activities?.order?.dine_in_order
    ) {
      setDisplayDineInNext(true);
    }
    if (
      props?.onboarding?.sessionSettings?.restaurant_open ||
      props?.onboarding?.future_activities?.order?.skip_line
    ) {
      setDisplaySkipNext(true);
    }
    if (
      props?.onboarding?.sessionSettings?.restaurant_open ||
      props?.onboarding?.future_activities?.order?.home_delivery
    ) {
      setDisplayDeliveryNext(true);
    }

    if (props?.onboarding?.sessionSettings?.restaurant_open) {
      setShowNowButton(true);
    }

    /*************************************
     * @DESC Take Away Action
     ************************************/
    if (props?.servicesEnabled?.take_away?.value) {
      if (
        props?.sessionSettings?.take_away
        //  || props?.futureOrders?.take_away
      ) {
        setShowTakeAway(true);
      } else {
        setShowTakeAway(false);
      }
    }
    if (
      props?.servicesEnabled?.take_away?.order_for_future &&
      props?.futureOrders?.take_away
    ) {
      setShowLaterTakeAway(true);
    }

    /*************************************
     * @DESC Cubside Delivery Action
     ************************************/
    if (props?.servicesEnabled?.cubside_delivery?.value) {
      if (
        props?.sessionSettings?.curb_side
        //  || props?.futureOrders?.curb_side
      ) {
        setShowCurbSide(true);
      } else {
        setShowCurbSide(false);
      }
    }
    if (
      props?.servicesEnabled?.cubside_delivery?.order_for_future &&
      props?.futureOrders?.curb_side
    ) {
      setShowLaterCurbSide(true);
    }

    /*************************************
     * @DESC Dine In Order Action
     ************************************/
    if (props?.servicesEnabled?.dine_in_order?.value) {
      if (
        props?.sessionSettings?.dine_in_order
        //  || props?.futureOrders?.dine_in_order
      ) {
        setShowDineIn(true);
      } else {
        setShowDineIn(false);
      }
    }
    if (
      props?.servicesEnabled?.dine_in_order?.order_for_future &&
      props?.futureOrders?.dine_in_order
    ) {
      setShowLaterDineIn(true);
    }

    /*************************************
     * @DESC Home Delivery Order Action
     ************************************/
    if (props?.servicesEnabled?.home_delivery?.value) {
      if (
        props?.sessionSettings?.home_delivery
        // || props?.futureOrders?.home_delivery
      ) {
        setShowHomeDelivery(true);
      } else {
        setShowHomeDelivery(false);
      }
    }
    if (
      props?.servicesEnabled?.home_delivery?.order_for_future &&
      props?.futureOrders?.home_delivery
    ) {
      setShowLaterHomeDelivery(true);
    }

    /*************************************
     * @DESC Skip The Line Order Action
     ************************************/
    if (props?.servicesEnabled?.self_serve?.value) {
      if (
        props?.sessionSettings?.skip_line
        // || props?.futureOrders?.skip_line
      ) {
        setShowSkipTheLine(true);
      } else {
        setShowSkipTheLine(false);
      }
    }
    if (
      props?.servicesEnabled?.self_serve?.order_for_future &&
      props?.futureOrders?.skip_line
    ) {
      setShowLaterSkipTheLine(true);
    }

    /************* @DESC Current Status ***********/
    if (
      props?.servicesEnabled?.take_away?.value &&
      props?.sessionSettings?.take_away
    ) {
      onChangeOrderType(0);
    } else if (
      props?.servicesEnabled?.cubside_delivery?.value &&
      props?.sessionSettings?.curb_side
    ) {
      onChangeOrderType(1);
    } else if (
      props?.servicesEnabled?.dine_in_order?.value &&
      props?.sessionSettings?.dine_in_order
    ) {
      onChangeOrderType(3);
    } else if (
      props?.servicesEnabled?.home_delivery?.value &&
      props?.sessionSettings?.home_delivery
    ) {
      onChangeOrderType(7);
    } else if (
      props?.servicesEnabled?.self_serve?.value &&
      props?.sessionSettings?.skip_line
    ) {
      onChangeOrderType(2);
    } else {
      formik.setFieldValue('order_type', '');
    }
  }, [
    props.servicesEnabled,
    props.sessionSettings,
    props.futureOrders,
    props.onboarding,
  ]);

  const handleKeyPress = (event) => {
    if (event.key == 229 || event.key === ' ') {
      event.preventDefault();
    }
  };

  const onClickAddDineTotalPax = (paxValue) => {
    if (formik?.totalDinePax === paxValue) {
      Alert.error(`<h4>Party size already exits</h4>`, {
        position: 'top-right',
        effect: 'bouncyflip',
        beep: true,
        html: true,
        timeout: 3000,
        offset: 35,
      });
    } else if (paxValue > dineInMaximumPerson) {
      Alert.error(
        `<h4>Maximum party size is ${dineInMaximumPerson} PAX. Please try again</h4>`,
        {
          position: 'top-right',
          effect: 'bouncyflip',
          beep: true,
          html: true,
          timeout: 3000,
          offset: 35,
        }
      );
    } else {
      formik.setFieldValue('totalDinePax', paxValue);
    }
  };

  return (
    <React.Fragment>
      {props.auth.loader ? (
        <AmealioLoader />
      ) : (
        <React.Fragment>
          <div className="container-fluid superadmin-orderscomponent-main">
            <div className="row">
              <Media query="(min-width: 992px)">
                <div className="left-side-panel">
                  <LeftSideNavigation />
                </div>
              </Media>
              <div className="right-side-panel">
                <RightSideNavigation
                  leftText="vendorReview"
                  backButtonLink="/orderdashboard"
                  displayText="Back"
                />
                <div className="">
                  <div className="container-fluid add-order-top-margin mt-5 mt-md-4">
                    <div className="f24_700_HelveticaNeue pt-4 pt-md-0">
                      Add Order
                    </div>
                    {/* <h5>User Information</h5> */}
                    <div className="row">
                      <Form className="col-xl-8 col-lg-10 col-md-12 pb-5 mt-5">
                        <Form.Group>
                          <Row className="mb-3">
                            <Col md={8} className="mb-3">
                              <Row>
                                <Col xs={4} sm={4} md={3} lg={3} xl={3}>
                                  <Form.Group
                                    // className="reusableInputComponent-main mb-0"
                                    controlId={'country_code'}
                                  >
                                    <div className="input-phone-country-code-reusable w-100">
                                      <select
                                        id="user_details.country_code"
                                        name="user_details.country_code"
                                        value={
                                          formik.values?.user_details
                                            ?.country_code
                                        }
                                        onChange={formik.handleChange}
                                        className="w-100"
                                      >
                                        <option
                                          value={
                                            formik.values?.user_details
                                              ?.country_code
                                          }
                                        >
                                          {
                                            formik.values?.user_details
                                              ?.country_code
                                          }
                                        </option>
                                        {getCountries().map((country) => (
                                          <option
                                            key={country}
                                            value={
                                              '+' +
                                              getCountryCallingCode(country)
                                            }
                                          >
                                            {en[country]} (+
                                            {getCountryCallingCode(country)})
                                          </option>
                                        ))}
                                      </select>
                                    </div>
                                  </Form.Group>
                                </Col>

                                <Col md={6} xs={7}>
                                  <Form.Group>
                                    <NewInputText
                                      controlClass={'mobile_number'}
                                      //id="outlined-basic"
                                      placeHolder="Mobile Number"
                                      type="number"
                                      labelText="Phone Number"
                                      variant="outlined"
                                      extraClass={`w-100 mb-1 ${
                                        formik.errors.user_details &&
                                        formik.errors.user_details
                                          .mobile_number &&
                                        formik.touched.user_details &&
                                        formik.touched.user_details
                                          .mobile_number
                                          ? 'enError'
                                          : ''
                                      }`}
                                      onInput={maxLengthCheck}
                                      maxLength={10}
                                      //onKeyDown={InputNumberFunc}
                                      onKeyPress={(event) => {
                                        if (!/[0-9]/.test(event.key)) {
                                          event.preventDefault();
                                        }
                                      }}
                                      name="user_details.mobile_number"
                                      onChange={formik.handleChange}
                                      value={
                                        formik.values.user_details &&
                                        formik.values.user_details.mobile_number
                                      }
                                      onFocusOut={
                                        (formik.handleBlur,
                                        formik.values?.user_details
                                          ?.mobile_number.length >= 10
                                          ? handleNumber
                                          : null)
                                      }
                                      //onInvalid={formik.errors.email && formik.touched.email}
                                    />
                                    {formik.errors.user_details &&
                                    formik.errors.user_details.mobile_number &&
                                    formik.touched.user_details &&
                                    formik.touched.user_details
                                      .mobile_number ? (
                                      <div className="pho_14_regular text-danger">
                                        {
                                          formik.errors.user_details
                                            .mobile_number
                                        }
                                      </div>
                                    ) : null}
                                  </Form.Group>
                                </Col>
                              </Row>
                            </Col>
                            <Col md={5} xs={6}>
                              <TextField
                                id="first_name"
                                label="First Name"
                                variant="outlined"
                                // onKeyPress={handleKeyPress}
                                // onKeyPress={(event) => {
                                //   if (!/[aA-zZ]/.test(event.key)) {
                                //     event.preventDefault();
                                //   }
                                // }}
                                className={`w-100 ${
                                  formik.errors.user_details &&
                                  formik.errors.user_details.first_name &&
                                  formik.touched.user_details &&
                                  formik.touched.user_details.first_name
                                    ? 'enError'
                                    : ''
                                }`}
                                name="user_details.first_name"
                                onChange={formik.handleChange}
                                value={
                                  formik.values.user_details &&
                                  formik.values.user_details.first_name
                                }
                                onBlur={formik.handleBlur}
                              />
                              {formik.errors.user_details &&
                              formik.errors.user_details.first_name &&
                              formik.touched.user_details &&
                              formik.touched.user_details.first_name ? (
                                <div className="pho_14_regular text-danger">
                                  {formik.errors.user_details.first_name}
                                </div>
                              ) : null}
                            </Col>
                            <Col md={5} xs={6}>
                              <TextField
                                id="last_name"
                                label="Last Name"
                                variant="outlined"
                                className={`w-100 ${
                                  formik.errors.user_details &&
                                  formik.errors.user_details.last_name &&
                                  formik.touched.user_details &&
                                  formik.touched.user_details.last_name
                                    ? 'enError'
                                    : ''
                                }`}
                                // onKeyPress={handleKeyPress}
                                // onKeyPress={(event) => {
                                //   if (/[\s]/.test(event.key)) {
                                //     event.preventDefault();
                                //   }
                                // }}
                                name="user_details.last_name"
                                onChange={formik.handleChange}
                                value={
                                  formik.values.user_details &&
                                  formik.values.user_details.last_name
                                }
                                onBlur={formik.handleBlur}
                              />
                              {formik.errors.user_details &&
                              formik.errors.user_details.last_name &&
                              formik.touched.user_details &&
                              formik.touched.user_details.last_name ? (
                                <div className="pho_14_regular text-danger">
                                  {formik.errors.user_details.last_name}
                                </div>
                              ) : null}
                              <br />
                              <br />
                            </Col>
                          </Row>
                          <Row>
                            <Col sm={12}>
                              <div className="col-12 p-0">
                                <h3 className="f20-700 mb-2">Order Type</h3>
                                <h4 className="f14-500 mb-4">
                                  Select one relevant option from below
                                </h4>
                              </div>
                              <Media query="(min-width: 991px)">
                                <Row style={{ width: '50%' }}>
                                  {orderTypes.map((data, index) => {
                                    return (
                                      <Fragment key={index}>
                                        {data.show ? (
                                          <>
                                            <div
                                              className="col-3 mb-5 text-center"
                                              onClick={() =>
                                                onChangeOrderType(data.id)
                                              }
                                              key={data.id}
                                            >
                                              <div>
                                                <div
                                                  className={`d-flex align-items-center justify-content-center take-away-order-select
                                              ${
                                                ordertype === data.id &&
                                                `take-away-order-select-selected`
                                              }`}
                                                  style={{
                                                    borderRadius: '50px',
                                                    width: '55px',
                                                    height: '55px',
                                                    margin: '0 auto',
                                                  }}
                                                >
                                                  <Image
                                                    src={data.image}
                                                    // width="22px"
                                                    // height="25px"
                                                    className="rounded-circle img-fluid"
                                                  />
                                                </div>
                                                <div className="mt-3 f10-700">
                                                  {data.title}
                                                </div>
                                              </div>
                                            </div>
                                          </>
                                        ) : (
                                          <Fragment></Fragment>
                                        )}
                                      </Fragment>
                                    );
                                  })}
                                </Row>
                              </Media>
                              <Media query="(max-width: 991px)">
                                <Row>
                                  {orderTypes.map((data, index) => {
                                    return (
                                      <Fragment key={index}>
                                        {data.show ? (
                                          <>
                                            <div
                                              className="col text-center"
                                              onClick={() =>
                                                onChangeOrderType(data.id)
                                              }
                                              key={data.id}
                                            >
                                              <div>
                                                <div
                                                  className={`d-flex align-items-center justify-content-center take-away-order-select
                                              ${
                                                ordertype === data.id &&
                                                `take-away-order-select-selected`
                                              }`}
                                                  style={{
                                                    borderRadius: '50px',
                                                    width: '55px',
                                                    height: '55px',
                                                    margin: '0 auto',
                                                  }}
                                                >
                                                  <Image
                                                    src={data.image}
                                                    // width="22px"
                                                    // height="25px"
                                                    className="rounded-circle img-fluid"
                                                  />
                                                </div>
                                                <div className="mt-3 f10-700">
                                                  {data.title}
                                                </div>
                                              </div>
                                            </div>
                                          </>
                                        ) : (
                                          <Fragment></Fragment>
                                        )}
                                      </Fragment>
                                    );
                                  })}
                                </Row>
                              </Media>
                            </Col>
                            <Col sm={12}>
                              {(showTakeAway && ordertype === 0) ||
                              (showSkipTheLine && ordertype === 2) ? (
                                <>
                                  {showNowButton ||
                                  showLaterTakeAway ||
                                  showLaterSkipTheLine ? (
                                    <h5 className="f16-500 mb-4">
                                      {`Please select the option for your ${
                                        ordertype === 0
                                          ? 'take away'
                                          : 'skip the line'
                                      } order`}
                                    </h5>
                                  ) : (
                                    <> </>
                                  )}
                                  <div>
                                    {props?.restaurantCurrentStatus ? (
                                      showNowButton && showNowButton ? (
                                        <Button
                                          className={`btn btn-md py-3 f14-500 bg-white mr-4 shadow-sm ${
                                            takeaway === 0
                                              ? `take-away-order-select-selected`
                                              : `border-0`
                                          }`}
                                          style={{ color: '#000' }}
                                          onClick={() => {
                                            onChangeTakeAwayNow();
                                          }}
                                        >
                                          Now
                                        </Button>
                                      ) : (
                                        <></>
                                      )
                                    ) : (
                                      <></>
                                    )}
                                    {showLaterTakeAway ||
                                    showLaterSkipTheLine ? (
                                      <Button
                                        className={`btn btn-md py-3 f14-500 bg-white shadow-sm ${
                                          takeaway === 1
                                            ? `take-away-order-select-selected`
                                            : `border-0`
                                        }`}
                                        style={{
                                          color: '#000',
                                        }}
                                        onClick={() => {
                                          onChangeTakeAwayLater();
                                        }}
                                      >
                                        Later
                                      </Button>
                                    ) : (
                                      <> </>
                                    )}
                                  </div>
                                  <br />
                                  <br />
                                </>
                              ) : (
                                <></>
                              )}
                              {/* <Row> */}
                              <Col xs={12} className="p-0">
                                {(takeaway === 1 && ordertype === 0) ||
                                (takeaway === 1 && ordertype === 2) ? (
                                  <Fragment>
                                    <Row>
                                      <Col md={4} xs={12}>
                                        <div className="f16-500 mb-3">
                                          Select Date
                                        </div>
                                        <TextField
                                          defaultValue={minDate}
                                          label="Select Date"
                                          variant="outlined"
                                          type="date"
                                          values={formik.values.later_date}
                                          //onChange={formik.handleChange}
                                          onChange={(e) =>
                                            // console.log(e.target.value)
                                            onChangeDate(e.target.value)
                                          }
                                          className="w-100"
                                          InputLabelProps={{
                                            shrink: true,
                                          }}
                                          InputProps={{
                                            inputProps: {
                                              min: minDate,
                                              max:
                                                ordertype === 2
                                                  ? maxDateSkipLine
                                                  : maxDateTakeAway,
                                            },
                                          }}
                                          name="date"
                                        />
                                      </Col>
                                    </Row>
                                    {timeSlots && timeSlots.length > 0 && (
                                      <div className="mt-4 mb-4">
                                        <div className="f14-500 mb-2">
                                          Select Time
                                        </div>
                                        <div className="f10-400 mb-2 opacity5">
                                          The displayed time slots depend upon
                                          the availability of the restaurant.
                                        </div>
                                      </div>
                                    )}
                                    <Row
                                      style={{
                                        marginTop: '10px',
                                      }}
                                    >
                                      {timeSlots.map((data) => {
                                        // console.log(data);
                                        return (
                                          <Col
                                            xs={6}
                                            sm={3}
                                            md={2}
                                            className="mb-3"
                                            onClick={() => {
                                              y(
                                                data.id,
                                                data.value,
                                                data.title
                                              );
                                            }}
                                            key={data.id}
                                          >
                                            <Button
                                              className={`btn btn-md f14-500 bg-white mr-4 shadow-sm w-100 py-3 px-2 ${
                                                timeDate === data.id
                                                  ? `take-away-order-select-selected`
                                                  : `border-0`
                                              }`}
                                              style={{ color: '#000' }}
                                            >
                                              {data.title}
                                            </Button>
                                          </Col>
                                        );
                                      })}
                                    </Row>
                                  </Fragment>
                                ) : (
                                  <></>
                                )}
                              </Col>
                              {/* </Row> */}
                              {ordertype === 1 && (
                                <>
                                  {ordertype === 1 && showCurbSide && (
                                    <>
                                      {showNowButton || showLaterCurbSide ? (
                                        <h4 className="f16-500 mb-4">
                                          Please select the option for your Curb
                                          Side order
                                        </h4>
                                      ) : (
                                        <> </>
                                      )}
                                      <div>
                                        {props?.restaurantCurrentStatus ? (
                                          showNowButton ? (
                                            <Button
                                              className={`btn btn-md py-3 f14-500 bg-white mr-4 shadow-sm ${
                                                takeaway === 0
                                                  ? `take-away-order-select-selected`
                                                  : `border-0`
                                              }`}
                                              style={{ color: '#000' }}
                                              onClick={() => {
                                                onChangeTakeAwayNow();
                                              }}
                                            >
                                              Now
                                            </Button>
                                          ) : (
                                            <></>
                                          )
                                        ) : (
                                          <></>
                                        )}
                                        {showLaterCurbSide ? (
                                          <Button
                                            className={`btn btn-md py-3 f14-500 bg-white shadow-sm ${
                                              takeaway === 1
                                                ? `take-away-order-select-selected`
                                                : `border-0`
                                            }`}
                                            style={{
                                              color: '#000',
                                            }}
                                            onClick={() => {
                                              onChangeTakeAwayLater();
                                            }}
                                          >
                                            Later
                                          </Button>
                                        ) : (
                                          <> </>
                                        )}
                                      </div>
                                      <br />
                                      <br />
                                    </>
                                  )}
                                  <Row>
                                    <Col xs={12}>
                                      {takeaway === 1 && ordertype === 1 && (
                                        <Fragment>
                                          <Row>
                                            <Col md={4} xs={12}>
                                              <div className="f16-500 mb-3">
                                                Select Date
                                              </div>
                                              <TextField
                                                defaultValue={minDate}
                                                label="Select Date"
                                                variant="outlined"
                                                type="date"
                                                values={
                                                  formik.values.later_date
                                                }
                                                //onChange={formik.handleChange}
                                                onChange={(e) =>
                                                  onChangeDate(e.target.value)
                                                }
                                                className="w-100"
                                                InputLabelProps={{
                                                  shrink: true,
                                                }}
                                                InputProps={{
                                                  inputProps: {
                                                    min: minDate,
                                                    max: maxDateCurbSide,
                                                  },
                                                }}
                                                name="date"
                                              />
                                            </Col>
                                          </Row>
                                          {timeSlots &&
                                            timeSlots.length > 0 && (
                                              <div className="mt-4 mb-4">
                                                <div className="f14-500 mb-2">
                                                  Select Time
                                                </div>
                                                <div className="f10-400 mb-2 opacity5">
                                                  The displayed time slots
                                                  depend upon the availability
                                                  of the restaurant Time
                                                </div>
                                              </div>
                                            )}
                                          <Row
                                            style={{
                                              // marginLeft: "2%",
                                              marginTop: '10px',
                                            }}
                                          >
                                            {timeSlots.map((data) => {
                                              return (
                                                <Col
                                                  xs={6}
                                                  sm={3}
                                                  md={2}
                                                  className="mb-3"
                                                  onClick={() => {
                                                    y(
                                                      data.id,
                                                      data.value,
                                                      data.title
                                                    );
                                                  }}
                                                  key={data.id}
                                                >
                                                  <Button
                                                    className={`btn btn-md f14-500 bg-white mr-4 shadow-sm w-100 py-3 px-2 ${
                                                      timeDate === data.id
                                                        ? `take-away-order-select-selected`
                                                        : `border-0`
                                                    }`}
                                                    style={{ color: '#000' }}
                                                  >
                                                    {data.title}
                                                  </Button>
                                                </Col>
                                              );
                                            })}
                                          </Row>
                                        </Fragment>
                                      )}
                                    </Col>
                                    {showNowButton || showLaterCurbSide ? (
                                      <Col xs={12}>
                                        <h5 className="f18-700 mt-4">
                                          Vehicle Information
                                        </h5>
                                        <p
                                          className="f10-400 w-75 mt-2"
                                          style={{ color: '#606060' }}
                                        >
                                          Please enter your vehicle number to
                                          get your order delivered near by your
                                          vehicle.
                                        </p>
                                        <p
                                          className="f10-400 w-75 mt-1"
                                          style={{ color: '#606060' }}
                                        >
                                          Do ensure that you are in or near by
                                          your vehicle.
                                        </p>
                                      </Col>
                                    ) : (
                                      <></>
                                    )}
                                    {showNowButton || showLaterCurbSide ? (
                                      <Col xs={8} className="my-4">
                                        <div className="container-fluid">
                                          <Row>
                                            {vechileTypes.map((data) => {
                                              return (
                                                <Col
                                                  md={2}
                                                  className="pl-0"
                                                  key={data.id}
                                                  xs={6}
                                                >
                                                  <div
                                                    className={`rounded-icons text-center m-auto
                                              ${
                                                vehical_type === data.id &&
                                                `rounded-icons-selected`
                                              }`}
                                                    // onClick={() => {
                                                    //   setState({
                                                    //     ...state,
                                                    //     vehical_type: data.id,
                                                    //   });
                                                    // }}
                                                    onClick={() =>
                                                      onClickChangeVechileType(
                                                        data
                                                      )
                                                    }
                                                  >
                                                    <img
                                                      className="rounded-circle"
                                                      src={data.icon}
                                                      alt={data.title}
                                                      width="100%"
                                                    />
                                                  </div>
                                                  <h5 className="f10-700 mt-2 text-center">
                                                    {data.title}
                                                  </h5>
                                                </Col>
                                              );
                                            })}
                                          </Row>
                                        </div>
                                      </Col>
                                    ) : (
                                      <></>
                                    )}
                                    {showNowButton || showLaterCurbSide ? (
                                      <Col md={6} xs={8}>
                                        <TextField
                                          label="Vehicle Number"
                                          variant="outlined"
                                          type="text"
                                          className={`w-100 ${
                                            formik.errors.number &&
                                            formik.touched.curb_side_details &&
                                            formik.touched.curb_side_details
                                              .number
                                              ? 'enError'
                                              : ''
                                          }`}
                                          inputProps={{ maxLength: 13 }}
                                          name="curb_side_details.number"
                                          value={
                                            formik.values.curb_side_details
                                              .number
                                          }
                                          onChange={formik.handleChange}
                                          onBlur={formik.handleBlur}
                                        />
                                        {formik.errors.number &&
                                        formik.touched &&
                                        formik.touched.curb_side_details &&
                                        formik.touched.curb_side_details
                                          .number ? (
                                          <div className="pho_14_regular text-danger">
                                            {formik.errors.number}
                                          </div>
                                        ) : null}
                                        <FormHelperText id="component-helper-text">
                                          Ex: AB 00 AB 0000
                                        </FormHelperText>
                                        <br />
                                        <br />
                                      </Col>
                                    ) : (
                                      <></>
                                    )}
                                    {showNowButton || showLaterCurbSide ? (
                                      <Col xs={12}>
                                        <Row>
                                          <Col md={3} xs={6}>
                                            <TextField
                                              label="Brand"
                                              variant="outlined"
                                              className={`w-100 ${
                                                formik.errors.make &&
                                                formik.touched
                                                  .curb_side_details &&
                                                formik.touched.curb_side_details
                                                  .make
                                                  ? 'enError'
                                                  : ''
                                              }`}
                                              name="curb_side_details.make"
                                              value={
                                                formik.values.curb_side_details
                                                  .make
                                              }
                                              onChange={formik.handleChange}
                                              onBlur={formik.handleBlur}
                                            />

                                            {formik.errors.make &&
                                            formik.touched &&
                                            formik.touched.curb_side_details &&
                                            formik.touched.curb_side_details
                                              .make ? (
                                              <div className="pho_14_regular text-danger">
                                                {formik.errors.make}
                                              </div>
                                            ) : null}
                                            <br />
                                          </Col>
                                          {/* <Col md={3} xs={6}>
                                            <TextField
                                              label="Model"
                                              variant="outlined"
                                              className={`w-100 ${formik.errors.model &&
                                                formik.touched
                                                  .curb_side_details &&
                                                formik.touched.curb_side_details
                                                  .model
                                                ? "enError"
                                                : ""
                                                }`}
                                              name="curb_side_details.model"
                                              value={
                                                formik.values.curb_side_details
                                                  .model
                                              }
                                              onChange={formik.handleChange}
                                              onBlur={formik.handleBlur}
                                            />

                                            {formik.errors.model &&
                                              formik.touched &&
                                              formik.touched.curb_side_details &&
                                              formik.touched.curb_side_details
                                                .model ? (
                                              <div className="pho_14_regular text-danger">
                                                {formik.errors.model}
                                              </div>
                                            ) : null}
                                            <br />
                                          </Col> */}
                                          {/* <Col
                                            md={2}
                                            xs={6}
                                            className="mobile-mt-2"
                                          >
                                            <NewInputText
                                              controlClass={
                                                "curb_side_details.year"
                                              }
                                              //id="outlined-basic"
                                              placeHolder="Year"
                                              type="number"
                                              labelText="Year"
                                              variant="outlined"
                                              extraClass={`w-100 mb-1 ${formik.errors.year &&
                                                formik.touched
                                                  .curb_side_details &&
                                                formik.touched.curb_side_details
                                                  .year
                                                ? "enError"
                                                : ""
                                                }`}
                                              onInput={maxLengthCheck}
                                              maxLength={4}
                                              onKeyPress={(event) => {
                                                if (!/[0-9]/.test(event.key)) {
                                                  event.preventDefault();
                                                }
                                              }}
                                              onChange={formik.handleChange}
                                              name="curb_side_details.year"
                                              value={
                                                formik.values.curb_side_details
                                                  .year
                                              }
                                              onFocusOut={formik.handleBlur}
                                            //onInvalid={formik.errors.email && formik.touched.email}
                                            />
                                            {formik.errors.year &&
                                              formik.touched &&
                                              formik.touched.curb_side_details &&
                                              formik.touched.curb_side_details
                                                .year ? (
                                              <div className="pho_14_regular text-danger">
                                                {formik.errors.year}
                                              </div>
                                            ) : null}
                                            <br />
                                          </Col> */}
                                          <Col
                                            md={2}
                                            xs={6}
                                            className="mobile-mt-2"
                                          >
                                            <FormControl
                                              variant="outlined"
                                              className={`w-100 ${
                                                formik.errors.color &&
                                                formik.touched
                                                  .curb_side_details &&
                                                formik.touched.curb_side_details
                                                  .color
                                                  ? 'enError'
                                                  : ''
                                              }`}
                                              // disabled={true}
                                            >
                                              <InputLabel id="curb_side_details.color">
                                                Color
                                              </InputLabel>
                                              <Select
                                                id="curb_side_details.color"
                                                label="Color"
                                                labelId="curb_side_details.color"
                                                name="curb_side_details.color"
                                                value={
                                                  formik.values
                                                    .curb_side_details.color
                                                }
                                                onChange={formik.handleChange}
                                                onBlur={formik.handleBlur}
                                              >
                                                {CAR_COLORS &&
                                                  CAR_COLORS.map((color) => (
                                                    <MenuItem
                                                      value={`${color.value}`}
                                                    >
                                                      {color.name}
                                                    </MenuItem>
                                                  ))}
                                                {/* <MenuItem value="">
                                                <em>None</em>
                                              </MenuItem>
                                              <MenuItem value={10}>
                                                Ten
                                              </MenuItem>
                                              <MenuItem value={20}>
                                                Twenty
                                              </MenuItem>
                                              <MenuItem value={30}>
                                                Thirty
                                              </MenuItem> */}
                                              </Select>
                                            </FormControl>
                                            {/* <TextField
                                            id="curb_side_details.color"
                                            label="Color"
                                            variant="outlined"
                                            className={`w-100 ${
                                              formik.errors.color &&
                                              formik.touched
                                                .curb_side_details &&
                                              formik.touched.curb_side_details
                                                .color
                                                ? "enError"
                                                : ""
                                            }`}
                                            disabled={true}
                                            type="text"
                                            name="curb_side_details.color"
                                            value={
                                              formik.values.curb_side_details
                                                .color
                                            }
                                            onChange={formik.handleChange}
                                            onBlur={formik.handleBlur}
                                          /> */}
                                            {formik.errors.color &&
                                            formik.touched &&
                                            formik.touched.curb_side_details &&
                                            formik.touched.curb_side_details
                                              .color ? (
                                              <div className="pho_14_regular text-danger">
                                                {formik.errors.color}
                                              </div>
                                            ) : null}
                                            <br />
                                          </Col>
                                          {/* <Col md={2} xs={2}>
                                          <div
                                            style={{
                                              display: "inline-block",
                                              marginLeft: "10px",
                                              boxShadow: "0px 0px 10px gray",
                                              borderRadius: "50%",
                                            }}
                                          >
                                            <IconButton
                                              size="medium"
                                              onClick={() =>
                                                setBackground({
                                                  ...background,
                                                  picker: !background.picker,
                                                })
                                              }
                                            >
                                              <FormatColorFillOutlinedIcon
                                                style={{
                                                  color: background.color,
                                                }}
                                              />
                                            </IconButton>
                                          </div>
                                          {background.picker && (
                                            <ColorPicker
                                              onColorChange={onChangeHandler(
                                                "BACKGROUND"
                                              )}
                                            />
                                          )}
                                        </Col> */}
                                        </Row>
                                      </Col>
                                    ) : (
                                      <> </>
                                    )}
                                  </Row>
                                  {showNowButton || showLaterCurbSide ? (
                                    <Row>
                                      <Col xs={12}>
                                        <h5 className="f18-700 mt-4">
                                          Select Pickup Location
                                        </h5>
                                        <p
                                          className="f10-400 w-75 mt-2"
                                          style={{ color: '#606060' }}
                                        >
                                          Please select a convenient pickup
                                          location where you will be arriving
                                        </p>
                                        <FormControl
                                          variant="outlined"
                                          className={`w-50 mt-4 ${
                                            formik.errors.pickUpPoint &&
                                            formik.touched.curb_side_details &&
                                            formik.touched.curb_side_details
                                              .pickUpPoint
                                              ? 'enError'
                                              : ''
                                          }`}
                                        >
                                          <InputLabel id="curb_side_details.pickUpPoint">
                                            pickUpPoint
                                          </InputLabel>
                                          <Select
                                            id="curb_side_details.pickUpPoint"
                                            label="pickUpPoint"
                                            labelId="curb_side_details.pickUpPoint"
                                            name="curb_side_details.pickUpPoint"
                                            // value={
                                            //   formik.values.curb_side_details
                                            //     .pickUpPoint.name
                                            // }
                                            // onChange={formik.handleChange}
                                            onChange={handleChangePickupPoint}
                                            onBlur={formik.handleBlur}
                                          >
                                            {pickupPointData &&
                                              pickupPointData.map(
                                                (data, index) => (
                                                  <MenuItem
                                                    key={index}
                                                    value={index}
                                                  >
                                                    {data.name}
                                                  </MenuItem>
                                                )
                                              )}
                                          </Select>
                                        </FormControl>
                                        {formik.errors.pickUpPoint &&
                                        formik.touched &&
                                        formik.touched.curb_side_details &&
                                        formik.touched.curb_side_details
                                          .pickUpPoint ? (
                                          <div className="pho_14_regular text-danger">
                                            {formik.errors.pickUpPoint}
                                          </div>
                                        ) : null}
                                      </Col>
                                    </Row>
                                  ) : null}
                                </>
                              )}
                              {(ordertype === 3 && showDineIn) ||
                              (ordertype === 2 && showSkipTheLine) ? (
                                showNowButton || showLaterDineIn ? (
                                  <div className="container-fluid px-0">
                                    {props?.subscriptionData?.seating
                                      ?.table_management?.value ? (
                                      <>
                                        <h5 className="f16-700 mb-2">
                                          Table Information
                                        </h5>
                                        <p
                                          className="f11-400"
                                          style={{ color: '#606060' }}
                                        >
                                          Please enter your table number to get
                                          your order delivered at your table.
                                        </p>
                                        <br />
                                        <Row>
                                          <Col md={6} xs={12}>
                                            <FormControl
                                              variant="outlined"
                                              className={classes.formControl}
                                            >
                                              <InputLabel htmlFor="outlined-time">
                                                Table Number/Seat Number
                                              </InputLabel>
                                              <Select
                                                onChange={formik.handleChange}
                                                value={
                                                  formik.values.dine_in_details
                                                    .table_number
                                                }
                                                label="Table Number/Seat Number"
                                                inputProps={{
                                                  name: 'dine_in_details.table_number',
                                                  id: 'outlined-time',
                                                }}
                                                IconComponent={
                                                  KeyboardArrowDownIcon
                                                }
                                              >
                                                <MenuItem
                                                  value=""
                                                  disabled
                                                  selected
                                                >
                                                  Select Table Number
                                                </MenuItem>
                                                {availableTableData &&
                                                  availableTableData?.map(
                                                    (data, index) => {
                                                      return data.status ===
                                                        'AVAILABLE' ? (
                                                        <MenuItem
                                                          key={index}
                                                          value={
                                                            data.table_number
                                                          }
                                                          name={
                                                            data.table_number
                                                          }
                                                        >
                                                          {data.table_number}
                                                        </MenuItem>
                                                      ) : null;
                                                    }
                                                  )}
                                              </Select>
                                            </FormControl>
                                            {/* <TextField
                                          label="Table Number/Seat Number"
                                          variant="outlined"
                                          className={`w-100 ${
                                            formik.errors.table_number &&
                                            formik.touched.dine_in_details &&
                                            formik.touched.dine_in_details
                                              .table_number
                                              ? "enError"
                                              : ""
                                          }`}
                                          inputProps={{
                                            maxLength: 12,
                                          }}
                                          name="dine_in_details.table_number"
                                          value={
                                            formik.values.dine_in_details
                                              .table_number
                                          }
                                          onChange={formik.handleChange}
                                          onBlur={formik.handleBlur}
                                        /> */}

                                            {formik.errors.table_number &&
                                            formik.touched &&
                                            formik.touched.dine_in_details &&
                                            formik.touched.dine_in_details
                                              .table_number ? (
                                              <div className="pho_14_regular text-danger">
                                                {formik.errors.table_number}
                                              </div>
                                            ) : null}
                                            <br />
                                          </Col>
                                        </Row>
                                      </>
                                    ) : null}
                                    <Row>
                                      <Col md={6} xs={12}>
                                        <h5 className="f16-700 mb-2 mt-4">
                                          Party Size
                                        </h5>
                                        <p
                                          className="f11-400"
                                          style={{ color: '#606060' }}
                                        >
                                          Please select the number of Guests
                                          dining in.
                                        </p>
                                        <div className="py-3">
                                          {DINE_IN_TOTAL_PAX.map(
                                            (totalNumber, index) => {
                                              return (
                                                <React.Fragment key={index}>
                                                  <div
                                                    type="button"
                                                    className={`btn text-center mr-3 ${
                                                      totalNumber.value ===
                                                      formik.values.totalDinePax
                                                        ? 'text-white border-0'
                                                        : ''
                                                    } mb-3`}
                                                    style={{
                                                      width: '75px',
                                                      border:
                                                        '1px solid rgba(0,0,0,0.29)',
                                                      backgroundColor:
                                                        totalNumber.value ===
                                                        formik.values
                                                          .totalDinePax
                                                          ? '#EE3A23'
                                                          : '',
                                                      color:
                                                        (totalNumber.value ===
                                                          totalNumber.value) ===
                                                        formik.values
                                                          .totalDinePax
                                                          ? '#FFFFFF'
                                                          : '',
                                                    }}
                                                    onClick={() =>
                                                      onClickAddDineTotalPax(
                                                        totalNumber.value
                                                      )
                                                    }
                                                  >
                                                    {totalNumber.value}
                                                  </div>
                                                </React.Fragment>
                                              );
                                            }
                                          )}
                                        </div>
                                        <div className="f14-400 opacity5 mb-4">
                                          Or
                                        </div>
                                        <TextField
                                          label="No. of People"
                                          variant="outlined"
                                          type="number"
                                          className={`w-100 ${
                                            formik.errors.totalDinePax &&
                                            formik.touched.totalDinePax
                                              ? 'enError'
                                              : ''
                                          }`}
                                          onInput={maxLengthCheck}
                                          inputProps={{ maxLength: 5 }}
                                          onKeyPress={(event) => {
                                            if (!/[0-9]/.test(event.key)) {
                                              event.preventDefault();
                                            }
                                          }}
                                          name="totalDinePax"
                                          value={formik.values.totalDinePax}
                                          onChange={formik.handleChange}
                                          onBlur={formik.handleBlur}
                                        />

                                        {formik.errors.totalDinePax &&
                                        formik.touched &&
                                        formik.touched.totalDinePax ? (
                                          <div className="pho_14_regular text-danger">
                                            {formik.errors.totalDinePax}
                                          </div>
                                        ) : null}
                                        <br />
                                      </Col>
                                    </Row>
                                  </div>
                                ) : (
                                  <> </>
                                )
                              ) : (
                                ''
                              )}
                              {/* TODO Need to Complete */}
                              {ordertype === 7 && (
                                <>
                                  {ordertype === 7 && showHomeDelivery && (
                                    <>
                                      {showNowButton ||
                                      showLaterHomeDelivery ? (
                                        <h4 className="f16-500 mb-4">
                                          Please select the option for your home
                                          delivery order
                                        </h4>
                                      ) : (
                                        <> </>
                                      )}
                                      <div>
                                        {props?.restaurantCurrentStatus ? (
                                          showNowButton ? (
                                            <Button
                                              className={`btn btn-md py-3 f14-500 bg-white mr-4 shadow-sm ${
                                                takeaway === 0
                                                  ? `take-away-order-select-selected`
                                                  : `border-0`
                                              }`}
                                              style={{ color: '#000' }}
                                              onClick={() => {
                                                onChangeTakeAwayNow();
                                              }}
                                            >
                                              Now
                                            </Button>
                                          ) : (
                                            <></>
                                          )
                                        ) : (
                                          <></>
                                        )}
                                        {showLaterHomeDelivery && false ? (
                                          <Button
                                            className={`btn btn-md py-3 f14-500 bg-white shadow-sm ${
                                              takeaway === 1
                                                ? `take-away-order-select-selected`
                                                : `border-0`
                                            }`}
                                            style={{
                                              color: '#000',
                                            }}
                                            onClick={() => {
                                              onChangeTakeAwayLater();
                                            }}
                                          >
                                            Later
                                          </Button>
                                        ) : (
                                          <> </>
                                        )}
                                      </div>
                                      <br />
                                      <br />
                                    </>
                                  )}
                                </>
                              )}
                              {ordertype === 7 &&
                                (showNowButton || showLaterHomeDelivery ? (
                                  <div className="container-fluid">
                                    <h5>Delivery Address</h5>
                                    <br />
                                    <p>
                                      Please enter your address to get your
                                      order delivered. Do ensure that you are in
                                      or near by address.
                                    </p>
                                    <br />
                                    {
                                      <SavedAddress
                                        userData={userData}
                                        handleAddress={handleAddress}
                                        selectedAddress={selectedAddress}
                                        tempAddress={tempAddress}
                                        distCheck={distCheck}
                                      />
                                    }
                                    {/* {<Col xs={12}>
                                      <div
                                        className="container-fluid"
                                        style={{ marginBottom: "1%" }}
                                      >
                                        <Row>
                                          {deliveryTypes.map((data) => {
                                            return (
                                              <Col md={3} key={data.id} xs={6}>
                                                <div
                                                  className={`rounded-icons 
                                              ${deliverytype === data.id &&
                                                    `rounded-icons-selected`
                                                    }`}
                                                  onClick={() => {
                                                    this.setState({
                                                      deliverytype: data.id,
                                                    });
                                                  }}
                                                >
                                                  <img
                                                    className="rounded-circle"
                                                    src={data.icon}
                                                    alt={data.title}
                                                    width="100%"
                                                  />
                                                </div>
                                                {data.title}
                                              </Col>
                                            );
                                          })}
                                        </Row>
                                      </div>
                                    </Col>
                                    <br />
                                    <Row>
                                      <Col md={6}>
                                        <Row>
                                          <Col xs={12}>
                                            <TextField
                                              label="House Number"
                                              variant="outlined"
                                              className="w-100"
                                              name="housenumber"
                                            />
                                            <br />
                                            <br />
                                          </Col>
                                          <Col md={6}>
                                            <TextField
                                              label="Area"
                                              variant="outlined"
                                              className="w-100"
                                              name="area"
                                            />
                                            <br />
                                            <br />
                                          </Col>
                                          <Col md={6}>
                                            <TextField
                                              label="Locality"
                                              variant="outlined"
                                              className="w-100"
                                              name="locality"
                                            />
                                            <br />
                                            <br />
                                          </Col>
                                          <Col md={6}>
                                            <TextField
                                              label="City"
                                              variant="outlined"
                                              className="w-100"
                                              name="city"
                                            />
                                            <br />
                                            <br />
                                          </Col>
                                          <Col md={6}>
                                            <TextField
                                              label="PIN/ZIP Code"
                                              variant="outlined"
                                              className="w-100"
                                              name="pincode"
                                            />
                                            <br />
                                            <br />
                                          </Col>
                                        </Row>
                                      </Col>
                                    </Row>} */}
                                  </div>
                                ) : (
                                  <> </>
                                ))}
                              <div className="d-flex align-items-center pt-5">
                                <Button
                                  variant="outline-secondary"
                                  className="f12-500 mr-4 py-3"
                                  style={{ width: '15%' }}
                                  onClick={(e) =>
                                    history.push('/orderdashboard')
                                  }
                                >
                                  Cancel
                                </Button>
                                {/* showSkipTheLine showHomeDelivery showTakeAway
                              showCurbSide showDineIn showLaterTakeAway
                              showLaterCurbSide showLaterDineIn
                              showLaterSkipTheLine showLaterHomeDelivery */}
                                {state.ordertype === 0 &&
                                displayTakeAwayNext ? (
                                  <Button
                                    variant="danger"
                                    className="f12-500 py-3 text-white"
                                    style={{
                                      width: '15%',
                                      border: '1px solid #ee3a23',
                                    }}
                                    type="button"
                                    //onClick={(e) => handleShowTab("2")}
                                    //type="submit"
                                    // onClick={() => {
                                    //   history.push("/orderrequest");
                                    // }}
                                    onClick={(e) => onClickNext(e)}
                                  >
                                    Next
                                  </Button>
                                ) : (
                                  <> </>
                                )}
                                {state.ordertype === 1 &&
                                displayCurbSideNext ? (
                                  <Button
                                    variant="danger"
                                    className="f12-500 py-3 text-white"
                                    style={{
                                      width: '15%',
                                      border: '1px solid #ee3a23',
                                    }}
                                    type="button"
                                    onClick={(e) => onClickNext(e)}
                                  >
                                    Next
                                  </Button>
                                ) : (
                                  <> </>
                                )}
                                {state.ordertype === 3 &&
                                showDineIn &&
                                displayDineInNext ? (
                                  <Button
                                    variant="danger"
                                    className="f12-500 py-3 text-white"
                                    style={{
                                      width: '15%',
                                      border: '1px solid #ee3a23',
                                    }}
                                    type="button"
                                    onClick={(e) => onClickNext(e)}
                                  >
                                    Next
                                  </Button>
                                ) : (
                                  <> </>
                                )}
                                {state.ordertype === 2 &&
                                showSkipTheLine &&
                                displaySkipNext ? (
                                  <Button
                                    variant="danger"
                                    className="f12-500 py-3 text-white"
                                    style={{
                                      width: '15%',
                                      border: '1px solid #ee3a23',
                                    }}
                                    type="button"
                                    onClick={(e) => onClickNext(e)}
                                  >
                                    Next
                                  </Button>
                                ) : (
                                  <> </>
                                )}
                                {state.ordertype === 7 &&
                                displayDeliveryNext ? (
                                  <Button
                                    variant="danger"
                                    className="f12-500 py-3 text-white"
                                    style={{
                                      width: '15%',
                                      border: '1px solid #ee3a23',
                                    }}
                                    type="button"
                                    onClick={(e) => onClickNext(e)}
                                  >
                                    Next
                                  </Button>
                                ) : (
                                  <> </>
                                )}
                                {distModal && (
                                  <MinDistanceModal
                                    handleCancel={(e) => setDistModal(false)}
                                  />
                                )}
                              </div>
                            </Col>
                          </Row>
                        </Form.Group>
                      </Form>
                    </div>
                  </div>
                </div>
              </div>
              <Media query="(max-width: 991px)">
                <div className="bottom-panel">
                  <BottomNavigationMobile />
                </div>
              </Media>
            </div>
          </div>
        </React.Fragment>
      )}
    </React.Fragment>
  );
};

const vechileTypes = [
  {
    id: 4,
    title: '4-wheeler',
    icon: require('../../../../assets/images/superadmin/ordericon/car.svg'),
  },
  {
    id: 2,
    title: '2-wheeler',
    icon: require('../../../../assets/images/superadmin/ordericon/scooter.svg'),
  },
  {
    id: 3,
    title: '3-wheeler',
    icon: require('../../../../assets/images/superadmin/ordericon/rikshaw.svg'),
  },
  {
    id: 0,
    title: 'Others',
    icon: require('../../../../assets/images/superadmin/ordericon/taxi.svg'),
  },
];

const deliveryTypes = [
  {
    id: 0,
    title: 'Indepdent House',
    icon: require('../../../../assets/images/superadmin/ordericon/house.svg'),
  },
  {
    id: 1,
    title: 'HighRise',
    icon: require('../../../../assets/images/superadmin/ordericon/HighRise.svg'),
  },
  {
    id: 2,
    title: 'Community',
    icon: require('../../../../assets/images/superadmin/ordericon/Community.svg'),
  },
  {
    id: 3,
    title: 'Gated',
    icon: require('../../../../assets/images/superadmin/ordericon/gated.svg'),
  },
];

AddOrder.propTypes = {
  auth: PropTypes.object.isRequired,
  get_category_menu_setup: PropTypes.func.isRequired,
  get_category_menu_setup_with_loader: PropTypes.func.isRequired,
  get_current_restaurant_opening_status: PropTypes.func.isRequired,
  get_offers_details: PropTypes.func.isRequired,
  create_or_check_user_order: PropTypes.func.isRequired,
  get_takeAway_time: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  restaurantCurrentStatus:
    state?.onboarding?.restaurantDetails?.sessionSettings?.restaurant_open,
  allergy_info: state.category.allergy_info,
  menuCategoryItems: state.onboarding.menuCategoryItems,
  activeItemId: state.onboarding.activeItemId,
  orderData: state.vendorOrdering.vendor_order_data,
  menuCategory: state.onboarding.menuCategory,
  //food_type: state.onboarding.restaurantDetails.selected_food_type,
  servicesEnabled: state?.onboarding?.onboard_subscription_details
    ?.fast_food_dining
    ? state?.onboarding?.onboard_subscription_details?.fast_food_dining_status
        ?.ordering
    : state?.onboarding?.onboard_subscription_details?.casual_dining
    ? state?.onboarding?.onboard_subscription_details?.casual_dining_status
        ?.ordering
    : state?.onboarding?.onboard_subscription_details
        ?.multi_service_business_status?.ordering,
  sessionSettings:
    state.onboarding &&
    state.onboarding.restaurantDetails &&
    state.onboarding.restaurantDetails.orderSessionSettings,
  futureOrders:
    state.onboarding &&
    state.onboarding.restaurantDetails &&
    state.onboarding.restaurantDetails.future_activities &&
    state.onboarding.restaurantDetails.future_activities.order,
  onboarding: state?.onboarding?.restaurantDetails,
  deliveryConfig:
    state?.onboarding?.onboard_subscription_details?.deliveryConfig,
  getAvailableTableData: state.allDinerDetails.get_vendor_available_table_data,
  subscriptionData: state?.onboarding?.onboard_subscription_details
    ?.casual_dining
    ? state?.onboarding?.onboard_subscription_details?.casual_dining_status
    : state?.onboarding?.onboard_subscription_details?.fast_food_dining
    ? state?.onboarding?.onboard_subscription_details?.fast_food_dining_status
    : state?.onboarding?.onboard_subscription_details?.multi_service_business
    ? state?.onboarding?.onboard_subscription_details
        ?.multi_service_business_status
    : '',
  subscription: state.onboarding.onboard_subscription_details,
  // &&
  //state.onboarding.restaurantDetails.sessionSettings,
});

export default connect(mapStateToProps, {
  get_category_menu_setup,
  get_category_menu_setup_with_loader,
  get_current_restaurant_opening_status,
  create_or_check_user_order,
  get_takeAway_time,
  get_offers_details,
  vendor_get_available_table_action,
  dunzoQuote,
})(AddOrder);
